<template>
  <router-view />
</template>

<script>
export default {
  name: "BatchesPage"
}
</script>

<style scoped>

</style>
